import axios from "@/app/Axios";

class Reposiciones {

    async listareposicioncuchillo() {
        try {
            const response = await axios.get("/reposicion/cuchilloreposicionlista");
            return response.data;
        } catch (error) {
            console.log(error);
            console.log(error.response.data);
            const errorData = error.response.data;
            return errorData;
        }
    }
    async listareposicioncuchilloejercito() {
        try {
            const response = await axios.get("/ejercito/cuchillodotacion");
            console.log("Es una lista de Servicion",response);
            return response.data.data;
        } catch (error) {
            console.log(error);
            console.log(error.response.data);
            const errorData = error.response.data;
            return errorData;
        }
    }
    async listareposicioncuchilloaerea() {
        try {
            const response = await axios.get("/aerea/cuchillodotacion");
            console.log("Es una lista de Servicion", response);
            return response.data.data;
        } catch (error) {
            console.log(error);
            console.log(error.response.data);
            const errorData = error.response.data;
            return errorData;
        }
    }
    async listareposicioncuchilloarmada() {
        try {
            const response = await axios.get("/armada/cuchillodotacion");
            console.log("Es una lista de Servicion", response);
            return response.data.data;
        } catch (error) {
            console.log(error);
            console.log(error.response.data);
            const errorData = error.response.data;
            return errorData;
        }
    }
    //EJERCITO
    async listareposicionpistolaejercito() {
        try {
            const response = await axios.get("/ejercito/pistolareposicionget");
            console.log("Es una lista de Servicion", response);
            return response.data.data;
        } catch (error) {
            console.log(error);
            console.log(error.response.data);
            const errorData = error.response.data;
            return errorData;
        }
    }
    //AEREA
    async listareposicionpistolaaerea() {
        try {
            const response = await axios.get("/aerea/pistolareposicionget");
            console.log("Es una lista de Servicion", response);
            return response.data.data;
        } catch (error) {
            console.log(error);
            console.log(error.response.data);
            const errorData = error.response.data;
            return errorData;
        }
    }
    //ARMADA
    async listareposicionpistoladearmada() {
        try {
            const response = await axios.get("/armada/pistolareposicionget");
            console.log("Es una lista de Servicion", response);
            return response.data.data;
        } catch (error) {
            console.log(error);
            console.log(error.response.data);
            const errorData = error.response.data;
            return errorData;
        }
    }
    async listareposicionpistolaarmada() {
        try {
            const response = await axios.get("/armada/pistoladotacion");
            console.log("Es una lista de Servicion", response);
            return response.data.data;
        } catch (error) {
            console.log(error);
            console.log(error.response.data);
            const errorData = error.response.data;
            return errorData;
        }
    }
    async listareposicionsableejercito() {
        try {
            const response = await axios.get("/ejercito/sabledotacion");
            console.log("Es una lista de Servicion", response);
            return response.data.data;
        } catch (error) {
            console.log(error);
            console.log(error.response.data);
            const errorData = error.response.data;
            return errorData;
        }
    }
    async listareposicionsableaerea() {
        try {
            const response = await axios.get("/aerea/sabledotacion");
            console.log("Es una lista de Servicion", response);
            return response.data.data;
        } catch (error) {
            console.log(error);
            console.log(error.response.data);
            const errorData = error.response.data;
            return errorData;
        }
    }
    async listareposicionsablearmada() {
        try {
            const response = await axios.get("/armada/sabledotacion");
            console.log("Es una lista de Servicion", response);
            return response.data.data;
        } catch (error) {
            console.log(error);
            console.log(error.response.data);
            const errorData = error.response.data;
            return errorData;
        }
    }
    async saveCuchilloReposicion(cuchillopost) {
        try {
            const response = await axios.post("/reposicion/cuchilloreposicionregistro", cuchillopost)
            console.log("Esta es respuesta:", response.data);
            return response.data

        } catch (error) {
            if (error.response && error.response.status === 401) {
                return error.response.data;
            } else {
                console.log(error);
            }
        }
    }
    async savePistolaReposicion(cuchillopost) {
        try {
            const response = await axios.post("/reposicion/pistolareposicionregistro", cuchillopost)
            console.log("Esta es respuesta:", response.data);
            return response.data

        } catch (error) {
            if (error.response && error.response.status === 401) {
                return error.response.data;
            } else {
                console.log(error);
            }
        }
    }
    async saveSableReposicion(cuchillopost) {
        try {
            const response = await axios.post("/reposicion/sablereposicionregistro", cuchillopost)
            console.log("Esta es respuesta:", response.data);
            return response.data

        } catch (error) {
            if (error.response && error.response.status === 401) {
                return error.response.data;
            } else {
                console.log(error);
            }
        }
    }

    async listaprocedencia() {
        try {
            const response = await axios.get("/listaprocedencia");
            console.log("Es una lista de Servicion Procedencia", response);
            return response.data.data;
        } catch (error) {
            console.log(error);
            console.log(error.response.data);
            const errorData = error.response.data;
            return errorData;
        }
    }

    async saveReposicionPistola(armaspost) {
        try {
            const response = await axios.post("/certificadosrepo/certificadosregistro", armaspost)
            console.log("Esta es la respuesta del registro del certificado:", response.data);
            return response.data

        } catch (error) {
            if (error.response && error.response.status === 401) {
                return error.response.data;
            } else {
                console.log(error);
            }
        }
    }

}

export default Reposiciones;